import styles from './TextError.module.scss';

export const TextError = ({ text }: { text: string }) => {
  return <div className={styles.textError}>{text}</div>;
};
